<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/student-training-duration`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h3>Указание количества месяцев обучения</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="iin" class="form-label col-md-3">
            ИИН
          </label>
          <div class="col-md-9">
            <input class="form-control" id="iin" type="text"
                   :disabled="true"
                   v-model="student.iin">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="lastname" class="form-label col-md-3">
            Фамилия
          </label>
          <div class="col-md-9">
            <input class="form-control" id="lastname" type="text"
                   :disabled="true"
                   v-model="student.lastname">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="firstname" class="form-label col-md-3">
            Имя
          </label>
          <div class="col-md-9">
            <input class="form-control" id="firstname" type="text"
                   :disabled="true"
                   v-model="student.firstname">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="patronymic" class="form-label col-md-3">
            Отчество
          </label>
          <div class="col-md-9">
            <input class="form-control" id="patronymic" type="text"
                   :disabled="true"
                   v-model="student.patronymic">
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="monthCount" class="form-label col-md-3">
            Количества месяцев
          </label>
          <div class="col-md-9">
            <input class="form-control" id="monthCount" type="number" :min="1" :max="4" :step="1"
                   v-model="student.trainingDuration.monthCount"
                   @input="validateMonthCount">
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="page-footer justify-content-end">
    <b-button variant="success" @click="onClickSave()">
      Сохранить
    </b-button>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import studentTrainingDurationService from "@/services/studentTrainingDurationService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";

export default {
  components: {
    VueLoading
  },
  computed: {
    studentId() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      student: {
        uuid: null,
        trancheYear: null,
        trancheNumber: null,
        trainingDuration: {
          uuid: null,
          monthCount: null
        },
        universityId: null,
        environmentalFactor: null,
        hasBranchEf: null,
        studentId: null,
        citizenshipId: null,
        iin: null,
        lastname: null,
        firstname: null,
        patronymic: null,
        degreeId: null,
        course: null,
        graduationCourse: null,
        deducted: null,
        admissionYear: null,
        gop: null,
        paymentFormId: null,
        quotaId: null,
        addStatusId: null,
        commentOvpo: null,
        environmentalFactorId: null,
        sightInvalid: null,
        sightInvalidBegin: null,
        sightInvalidEnd: null,
        hearingInvalid: null,
        hearingInvalidBegin: null,
        hearingInvalidEnd: null,
        orphan: null,
        stateProvisionOrphan: null,
        commentFc: null,
        enrollOrderDate: null,
        enrollOrderNumber: null,
        enrollOrderMoveDate: null,
        deductOrderDate: null,
        deductOrderNumber: null,
        deductOrderMoveDate: null,
        deductOrderTransferDate: null,
        deductOrderTransferNumber: null,
        deductOrderTransferMoveDate: null,
        deductOrderTransferUniversityDomestic: null,
        deductOrderTransferUniversityForeign: null,
        academicLeaveOrderDate: null,
        academicLeaveOrderNumber: null,
        academicLeaveOrderMoveDate: null,
        academicLeaveOrderStartDate: null,
        academicLeaveOrderFinishDate: null,
        academicLeaveOrderReason: null,
        academicLeaveOrderSickLeaveStartDate: null,
        academicLeaveOrderSickLeaveFinishDate: null,
        orderChangeGopDate: null,
        orderChangeGopNumber: null,
        orderChangeGopMoveDate: null,
        orderChangeGopOldGop: null,
        orderChangePaymentFormGrantDate: null,
        orderChangePaymentFormGrantNumber: null,
        orderChangePaymentFormGrantMoveDate: null,
        orderAcademicMobilityDate: null,
        orderAcademicMobilityNumber: null,
        orderAcademicMobilityMoveDate: null,
        orderAcademicMobilityUniversityDomestic: null,
        orderAcademicMobilityUniversityForeign: null,
        orderAcademicMobilityStartDate: null,
        orderAcademicMobilityFinishDate: null,
        orderDoubleEducationDate: null,
        orderDoubleEducationNumber: null,
        orderDoubleEducationMoveDate: null,
        orderDoubleEducationUniversityDomestic: null,
        orderDoubleEducationUniversityForeign: null,
        orderDoubleEducationStartDate: null,
        orderDoubleEducationFinishDate: null,
        enrollOrderFoundDate: null,
        enrollOrderFoundNumber: null,
        enrollOrderFoundMoveDate: null,
        deductOrderFoundDate: null,
        deductOrderFoundNumber: null,
        deductOrderFoundMoveDate: null,
        orderScholarshipDate: null,
        orderScholarshipNumber: null,
        orderScholarshipFoundDate: null,
        orderScholarshipFoundNumber: null,
        scholarshipPeriodStart: null,
        scholarshipPeriodEnd: null,
        scholarshipType: null
      }
    };
  },
  methods: {
    init() {
      this.findById(this.studentId);
    },
    async findById(studentId) {
      this.isLoading = true;
      this.student = await studentTrainingDurationService.findById(studentId);
      if (this.student.trainingDuration == null) {
        this.student.trainingDuration = {};
      }
      this.isLoading = false;
    },
    async onClickSave() {
      try {
        this.isLoading = true;

        this.student = await studentTrainingDurationService.save(this.student);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    validateMonthCount() {
      if (this.student.trainingDuration.monthCount > 4) {
        this.student.trainingDuration.monthCount = 4;
      }
      if (this.student.trainingDuration.monthCount < 1) {
        this.student.trainingDuration.monthCount = 1;
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
